module.exports = __webpack_public_path__ + "fonts/698f46605dac9de0d06606c5726b352e.svg";